import { isNullOrEmpty } from "../../utils/string";
var ResourceCache = /** @class */ (function () {
    function ResourceCache() {
        this.mCache = new Map();
        this.onDisposeResource = null;
    }
    ResourceCache.prototype.has = function (pKey) {
        return (this.mCache.has(pKey));
    };
    ResourceCache.prototype.add = function (pKey, pResource) {
        if (isNullOrEmpty(pKey))
            return (false);
        this.mCache.set(pKey, { data: pResource, lastUsed: Date.now() });
        return (true);
    };
    ResourceCache.prototype.get = function (pKey) {
        if (isNullOrEmpty(pKey))
            return (null);
        var tResource = this.mCache.get(pKey);
        if (tResource != null) {
            tResource.lastUsed = Date.now();
            return (tResource.data);
        }
        else
            return (null);
    };
    ResourceCache.prototype.remove = function (pKey, pDispose) {
        if (pDispose === void 0) { pDispose = true; }
        if (isNullOrEmpty(pKey))
            return (false);
        if (pDispose && this.onDisposeResource != null) {
            var tResource = this.mCache.get(pKey);
            if (tResource != null)
                this.onDisposeResource(tResource.data, false);
        }
        return (this.mCache.delete(pKey));
    };
    ResourceCache.prototype.forEach = function (pCallback) {
        this.mCache.forEach(function (pResource, pKey, pMap) {
            pCallback(pKey, pResource.data);
        });
    };
    ResourceCache.prototype.clear = function (pDispose) {
        var _this = this;
        if (pDispose === void 0) { pDispose = true; }
        if (pDispose && this.onDisposeResource != null)
            this.mCache.forEach(function (pRes) { return _this.onDisposeResource(pRes.data, true); });
        this.mCache.clear();
    };
    ResourceCache.prototype.removeUnused = function (pUsedResources, pMaxTimeUnused, pDispose) {
        var _this = this;
        if (pDispose === void 0) { pDispose = true; }
        if (pUsedResources == null)
            return;
        var tNow = Date.now();
        this.mCache.forEach(function (pResource, pKey, pMap) {
            if (!pUsedResources.has(pKey)) {
                if (tNow - pResource.lastUsed > pMaxTimeUnused) {
                    _this.remove(pKey, pDispose);
                }
            }
        });
    };
    return ResourceCache;
}());
export { ResourceCache };
